import { Component } from '@angular/core';
import { UilabMatListModule } from '@uilab/ng-mat-components';
import { CodeExampleComponent } from 'src/app/shared/components/code-example/code-example.component';
import { CodeExampleHeaderComponent } from 'src/app/shared/components/code-example/code-example-header.component';
import { COMPONENT_EXAMPLES_CONSTANTS } from '../component-examples.constants';

interface ListExample {
    readonly variant: 'basic';
    readonly label: string;
    readonly description: string;
    readonly htmlSnippet: string;
    readonly items: readonly string[];
}

@Component({
    selector: 'avd-list-examples',
    templateUrl: './list-examples.component.html',
    styleUrls: ['./list-examples.component.scss'],
    imports: [
        CodeExampleHeaderComponent,
        CodeExampleComponent,
        UilabMatListModule,
    ],
})
export class ListExamplesComponent {
    readonly packageName = COMPONENT_EXAMPLES_CONSTANTS.PACKAGE_NAME;
    readonly getStartedLink = COMPONENT_EXAMPLES_CONSTANTS.GET_STARTED_LINK;
    readonly storybookLink =
        'https://calm-mushroom-0d2458d1e.2.azurestaticapps.net/?path=/story/components-list--default';
    readonly repoLink =
        'https://dev.azure.com/AVEVA-VSTS/UX/_git/uilab-base?version=GBfeat/angular-material-components&path=/projects/components/src/lib/list';

    readonly examples: readonly ListExample[] = [
        {
            variant: 'basic',
            label: 'Basic List',
            description:
                'Use a basic list to present related items in a simple, readable vertical group.',
            htmlSnippet: `<uilab-mat-list>
    <uilab-mat-list-item>Operator Handbook</uilab-mat-list-item>
    <uilab-mat-list-item>Shift Log</uilab-mat-list-item>
    <uilab-mat-list-item>Safety Checklist</uilab-mat-list-item>
</uilab-mat-list>`,
            items: ['Operator Handbook', 'Shift Log', 'Safety Checklist'],
        },
    ];
}
